import { ReactComponent as MaleIcon } from "../assets/icons/male_icon.svg";
import { ReactComponent as FemaleIcon } from "../assets/icons/female_icon.svg";
import { ReactComponent as StarIcon } from "../assets/icons/star.svg";
import { ReactComponent as CopyIcon } from "../assets/icons/copy.svg";
import { ReactComponent as PtsCopyIcon } from "../assets/icons/pts_copy.svg";
import { ReactComponent as PtsAnketaIcon } from "../assets/icons/pts_anketa.svg";
import { ReactComponent as PtsPuzzleIcon } from "../assets/icons/pts_puzzle.svg";
import { ReactComponent as PtsPuzzleOutlineIcon } from "../assets/icons/pts_puzzle_outline.svg";
import { ReactComponent as LogoutIcon } from "../assets/icons/log-out.svg";
import { ReactComponent as LoginIcon } from "../assets/icons/log-in.svg";
import { ReactComponent as TriangleIcon } from "../assets/icons/triangle.svg";
import { ReactComponent as PlusIcon } from "../assets/icons/plus.svg";
import { ReactComponent as TrashIcon } from "../assets/icons/trash.svg";
import { ReactComponent as Intouch_logo } from "../assets/icons/intouch_logo.svg";
import { ReactComponent as CloseCrossIcon } from "../assets/icons/close-cross.svg";
import { ReactComponent as GameButtonPositive } from "../assets/icons/button-positive.svg";
import { ReactComponent as GameButtonNeutral } from "../assets/icons/button-neutral.svg";
import { ReactComponent as GameButtonNegative } from "../assets/icons/button-negative.svg";
import { ReactComponent as GameCanIcon } from "../assets/icons/game-can.svg";
import { ReactComponent as GameCantIcon } from "../assets/icons/game-cant.svg";
import { ReactComponent as GameInterestingIcon } from "../assets/icons/game-interesting.svg";
import { ReactComponent as Line1 } from "../assets/icons/Vector_1.svg";
import { ReactComponent as Line2 } from "../assets/icons/Vector_2.svg";
import { ReactComponent as Line3 } from "../assets/icons/Vector_3.svg";
import { ReactComponent as QuestionIcon } from "../assets/icons/question.svg";
import { ReactComponent as CheckedIcon } from "../assets/icons/checked.svg";
import { ReactComponent as LeftArrowIcon } from "../assets/icons/left-arrow.svg";
import { ReactComponent as RightArrowIcon } from "../assets/icons/right-arrow.svg";
import { ReactComponent as UpArrowIcon } from "../assets/icons/up-arrow.svg";
import { ReactComponent as DownArrowIcon } from "../assets/icons/down-arrow.svg";
import { ReactComponent as InstagramIcon } from "../assets/icons/insta.svg";
import { ReactComponent as FacebookIcon } from "../assets/icons/facebook.svg";
import { ReactComponent as EmailIcon } from "../assets/icons/email.svg";
import { ReactComponent as ClockIcon } from "../assets/icons/time.svg";
import { ReactComponent as PencilIcon } from "../assets/icons/pencil.svg";
import { ReactComponent as CalendarIcon } from "../assets/icons/calendar.svg";
import { ReactComponent as SpinnerIcon } from "../assets/icons/spinner.svg";
import { ReactComponent as WideTopLine } from "../assets/icons/wide-line-top.svg";
import { ReactComponent as WideMiddleLine } from "../assets/icons/wide-line-middle.svg";
import { ReactComponent as WideBottomLine } from "../assets/icons/wide-line-bottom.svg";
import { ReactComponent as VKIcon } from "../assets/icons/vk.svg";
import { ReactComponent as LangArrowIcon } from "../assets/icons/lang_arrow.svg";
import { ReactComponent as LangChevronsIcon } from "../assets/icons/updown.svg";
import { ReactComponent as GlobeIcon } from "../assets/icons/globe.svg";
import { ReactComponent as SquarePencil } from "../assets/icons/square-pencil.svg";
import { ReactComponent as Mozaika } from "../assets/icons/mozaika.svg";
import { ReactComponent as Mozaika1 } from "../assets/icons/mozaika1.svg";
import { ReactComponent as CircleNotifyWarn } from "../assets/icons/circle_notify_warn.svg";

import { ReactComponent as BookmarkGradient } from "../assets/icons/bookmark_gradient.svg";
import { ReactComponent as BrowserGradient } from "../assets/icons/browser_gradient.svg";
import { ReactComponent as ButterflyGradient } from "../assets/icons/butterfly_gradient.svg";
import { ReactComponent as PencilGradient } from "../assets/icons/pencil_gradient.svg";
import { ReactComponent as ProfileGradient } from "../assets/icons/profile_gradient.svg";
import { ReactComponent as ShareGradient } from "../assets/icons/share_gradient.svg";
import { ReactComponent as ShareGradient1 } from "../assets/icons/share_gradient-1.svg";
import { ReactComponent as HandLike } from "../assets/icons/hand_like.svg";
import { ReactComponent as SupportGradient } from "../assets/icons/support_gradient.svg";
import { ReactComponent as BiggerLogout } from "../assets/icons/bigger_logout.svg";
import { ReactComponent as WomanLine } from "../assets/icons/women-line.svg";
import { ReactComponent as ManLine } from "../assets/icons/man-line.svg";
import { ReactComponent as CheckPurple } from "../assets/icons/check_purple.svg";
import { ReactComponent as ArrowRight } from "../assets/icons/arrow-right.svg";
import { ReactComponent as VosklicatelSign } from "../assets/icons/vosklicatel_sign.svg";
import { ReactComponent as HandHeart } from "../assets/icons/hand_heart.svg";
import { ReactComponent as TopTriangle } from "../assets/icons/top_triangle.svg";
import { ReactComponent as BottomTriangle } from "../assets/icons/bottom_triangle.svg";

import { ReactComponent as InsightIcon } from "../assets/icons/insight_form_icon.svg";
import { ReactComponent as InsightSmallIcon } from "../assets/icons/small_insight_form_ic.svg";
import { ReactComponent as NotifVosklSign } from "../assets/icons/notification_voskl_sign.svg";

import { ReactComponent as DoubleContradictions } from "../assets/icons/double_contradictions.svg";
import { ReactComponent as DoubleAgreement } from "../assets/icons/double_agreement.svg";
import { ReactComponent as DoubleDialogueIcon } from "../assets/icons/double_dialogue.svg";
import { ReactComponent as DoubleComfortIcon } from "../assets/icons/double_comfort.svg";
import { ReactComponent as DoubleInterestsIcon } from "../assets/icons/double_interests.svg";
import { ReactComponent as DoubleStudyIcon } from "../assets/icons/double_study_icon.svg";

import { ReactComponent as ExclamMark } from "../assets/icons/exclam_mark.svg";
import { ReactComponent as QuestiIcon } from "../assets/icons/questi_icon.svg";
import { ReactComponent as ArrowInRound } from "../assets/icons/arrow_in_round.svg";
import { ReactComponent as SmallArrowInRound } from "../assets/icons/small_arrow_in_round.svg";
import { ReactComponent as PurpleVosklSign } from "../assets/icons/purple_voskl_sign.svg";
import { ReactComponent as MainScreen } from "../assets/icons/main_screen.svg";
import { ReactComponent as MainScreenLight } from "../assets/icons/main_screen_light.svg";
import { ReactComponent as ExclamationMark } from "../assets/icons/exclamation_mark.svg";

import { ReactComponent as ShopIcon } from "../assets/icons/shop_icon.svg";
import { ReactComponent as ShopIcon2 } from "../assets/icons/shop_icon2.svg";
import { ReactComponent as InfoIcon } from "../assets/icons/info_icon.svg";
import { ReactComponent as CloseAlertIcon } from "../assets/icons/close_alert.svg";

export const icons = {
  male: MaleIcon,
  female: FemaleIcon,
  logout: LogoutIcon,
  login: LoginIcon,
  triangle: TriangleIcon,
  plus: PlusIcon,
  trash: TrashIcon,
  intouch_logo: Intouch_logo,
  close_cross: CloseCrossIcon,
  game_can: GameCanIcon,
  game_cant: GameCantIcon,
  game_interesting: GameInterestingIcon,
  line1: Line1,
  line2: Line2,
  line3: Line3,
  question: QuestionIcon,
  checked: CheckedIcon,
  left_arrow: LeftArrowIcon,
  right_arrow: RightArrowIcon,
  email: EmailIcon,
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  clock: ClockIcon,
  pencil: PencilIcon,
  calendar: CalendarIcon,
  spinner: SpinnerIcon,
  wideTopLine: WideTopLine,
  wideMiddleLine: WideMiddleLine,
  wideBottomLine: WideBottomLine,
  vk: VKIcon,
  up_arrow: UpArrowIcon,
  down_arrow: DownArrowIcon,
  lang_arrow: LangArrowIcon,
  lang_chevrons: LangChevronsIcon,
  globe: GlobeIcon,
  square_pencil: SquarePencil,
  mozaika: Mozaika,
  mozaika1: Mozaika1,
  bookmark_gradient: BookmarkGradient,
  browser_gradient: BrowserGradient,
  butterfly_gradient: ButterflyGradient,
  star: StarIcon,
  copy: CopyIcon,
  pts_copy: PtsCopyIcon,
  pts_anketa: PtsAnketaIcon,
  pts_puzzle: PtsPuzzleIcon,
  pts_puzzle_outline: PtsPuzzleOutlineIcon,
  pencil_gradient: PencilGradient,
  profile_gradient: ProfileGradient,
  share_gradient: ShareGradient,
  share_gradient_white: ShareGradient1,
  support_gradient: SupportGradient,
  bigger_logout: BiggerLogout,
  game_button_positive: GameButtonPositive,
  game_button_neutral: GameButtonNeutral,
  game_button_negative: GameButtonNegative,
  woman_line: WomanLine,
  man_line: ManLine,
  check_purple: CheckPurple,
  arrow_right: ArrowRight,
  vosklicatel_sign: VosklicatelSign,
  hand_heart: HandHeart,
  insight_form_icon: InsightIcon,
  small_insight_form_icon: InsightSmallIcon,
  top_triangle: TopTriangle,
  bottom_triangle: BottomTriangle,
  notif_voskl_sign: NotifVosklSign,
  circle_notify_warn: CircleNotifyWarn,
  double_comfort_icon: DoubleComfortIcon,
  double_interests_icon: DoubleInterestsIcon,
  double_study_icon: DoubleStudyIcon,
  double_dialogue_icon: DoubleDialogueIcon,
  double_contradictions_icon: DoubleContradictions,
  double_agreement_icon: DoubleAgreement,
  questi_icon: QuestiIcon,
  exclam_icon: ExclamMark,
  arrow_in_round: ArrowInRound,
  small_arrow_in_round: SmallArrowInRound,
  purple_voskl_sign: PurpleVosklSign,
  hand_like: HandLike,
  main_screen: MainScreen,
  main_screen_light: MainScreenLight,
  exclamation_mark: ExclamationMark,
  shop_icon: ShopIcon,
  shop_icon2: ShopIcon2,
  info_icon: InfoIcon,
  close_alert: CloseAlertIcon,
};
